import { useEffect } from 'react';

export default () => {
  useEffect(() => {
    const script = document.createElement('script');
    document.body.appendChild(script);
    script.src = 'https://x.klarnacdn.net/xs2a/app-launcher/v0/xs2a-app-launcher.js';
    script.async = true;

    return () => {
      document.body.removeChild(script);
    };
  }, []);
};
